import React, { useEffect, useState } from 'react';

const MODULE_NAME = "_118_admin_banner";

/**
 * AdminBanner fetches admin notifications from the backend and displays them.
 * Each notification can be dismissed individually (dismissal stored in sessionStorage for the session).
 * Dismissal is tracked by a unique key per notification (short_desc + date).
 */
function AdminBanner() {
    const [accountType, setAccountType] = useState("");
    const [notifications, setNotifications] = useState([]);
    const [dismissedKeys, setDismissedKeys] = useState([]);

    useEffect(() => {
        // Load dismissed notification keys from sessionStorage
        const dismissed = JSON.parse(sessionStorage.getItem("dismissedAdminNotifications") || "[]");
        setDismissedKeys(dismissed);

        fetch(`${process.env.REACT_APP_API_URL}/api/admin-banner`, {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                setAccountType(data.account_type || "");
                setNotifications(Array.isArray(data.notifications) ? data.notifications : []);
            })
            .catch((err) => {
                console.error("Fetch error:", err);
                setAccountType("");
                setNotifications([]);
            });
    }, []);

    // Use a unique key for each notification (short_desc + date)
    const getNotifKey = notif => `${notif.short_desc || ""}_${notif.date || ""}`;

    const handleDismiss = (notif) => {
        const key = getNotifKey(notif);
        const newDismissed = [...dismissedKeys, key];
        setDismissedKeys(newDismissed);
        sessionStorage.setItem("dismissedAdminNotifications", JSON.stringify(newDismissed));
    };

    if (accountType !== "admin") {
        return null;
    }

    // Only show notifications that are not dismissed
    const visibleNotifications = notifications.filter(
        notif => !dismissedKeys.includes(getNotifKey(notif))
    );

    if (visibleNotifications.length === 0) {
        return null;
    }

    return (
        <div
            className="user-banner admin-banner"
            data-analytics={MODULE_NAME}
            style={{
                textAlign: "center",
                padding: "8px 16px",
                background: "rgba(255, 77, 79, 0.1)",
                border: "1px solid rgba(255, 77, 79, 0.3)",
                borderRadius: "8px",
                margin: "8px 16px 0 16px",
                position: "relative"
            }}
        >
            {visibleNotifications.map((notif, idx) => (
                <div
                    key={getNotifKey(notif)}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "16px",
                        marginBottom: "8px",
                        background: "#fff",
                        borderRadius: "6px",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                        padding: "10px 16px",
                        borderLeft: notif.type === "error"
                            ? "4px solid #ff4d4f"
                            : notif.type === "warning"
                                ? "4px solid #faad14"
                                : notif.type === "success"
                                    ? "4px solid #52c41a"
                                    : "4px solid #1890ff"
                    }}
                >
                    <div style={{ flex: 1, textAlign: "left" }}>
                        <div style={{ fontWeight: 600, color: "#ff4d4f", fontSize: "14px" }}>
                            {notif.short_desc}
                        </div>
                        <div style={{ color: "#333", fontSize: "13px", margin: "4px 0" }}>
                            {notif.message}
                        </div>
                        <div style={{ color: "#888", fontSize: "12px" }}>
                            {notif.date}
                        </div>
                    </div>
                    <button
                        onClick={() => handleDismiss(notif)}
                        style={{
                            background: "transparent",
                            border: "none",
                            color: "#ff4d4f",
                            fontSize: "48px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            marginLeft: 8,
                            padding: "0px 8px",
                            lineHeight: "1",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            minWidth: "48px",
                            minHeight: "48px"
                        }}
                        aria-label="Dismiss notification"
                        title="Dismiss"
                    >
                        ×
                    </button>
                </div>
            ))}
        </div>
    );
}

export default AdminBanner;